import DefaultFooter from '@/components/App/Footer/DefaultFooter';
import BookingPage from '@/pages/BookingPassenger/BookingPassenger.page';
import BookingConfirmationPage from '@/pages/BookingConfirmation/BookingConfirmation.page';
import HomePage from '@/pages/Home/Home.page';
import HotelDetailPage from '@/pages/HotelDetail/HotelDetail.page';
import HotelSearchPage from '@/pages/HotelSearch/HotelSearch.page';
import PaymentPage from '@/pages/BookingPayment/BookingPayment.page';
import { AppUrls } from '@/urls';
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import BookingSuccessPage from '@/pages/BookingSuccess/BookingSuccess.page';
import BookingFailedPage from '@/pages/BookingFailed/BookingFailed.page';
import BookingCancelledFailed from '@/pages/BookingCancelledFailed/BookingCancelledFailed.page';
import BookingCancelledSuccess from '@/pages/BookingCancelledSuccess/BookingCancelledSuccess.page';
import OnHoldPaymentPage from '@/pages/OnHoldPayment/OnHoldPayment.page';
import BookingNeed2CheckPage from '@/pages/BookingNeed2Check/BookingNeed2Check.page';
import Page401 from '@/pages/Page401/Page401';
import CampaignsPage from '@/pages/Campaigns/CampaignsPage';

export default function DefaultLayout() {
  return (
    <>
      <Switch>
        <Route exact path={AppUrls.HomePage} component={HomePage} />
        <Route exact path={AppUrls.HotelSearch} component={HotelSearchPage} />
        <Route exact path={AppUrls.HotelDetail} component={HotelDetailPage} />
        <Route exact path={AppUrls.BookingConfirmation} component={BookingConfirmationPage} />
        <Route exact path={AppUrls.BookingPassenger} component={BookingPage} />
        <Route exact path={AppUrls.BookingPayment} component={PaymentPage} />
        <Route exact path={AppUrls.OnHoldPayment} component={OnHoldPaymentPage} />

        <Route exact path={AppUrls.BookingSuccess} component={BookingSuccessPage} />
        <Route exact path={AppUrls.BookingFailed} component={BookingFailedPage} />
        <Route exact path={AppUrls.BookingCancelledFailed} component={BookingCancelledFailed} />
        <Route exact path={AppUrls.BookingCancelledSuccess} component={BookingCancelledSuccess} />
        <Route exact path={AppUrls.BookingNeedToCheck} component={BookingNeed2CheckPage} />
        <Route exact path={AppUrls.CampaignDetail} component={CampaignsPage} />

        <Route exact path={AppUrls.Page401} component={Page401} />

        <Redirect from="*" to={AppUrls.HomePage} />
      </Switch>
      <DefaultFooter />
    </>
  );
}
